/**
 * @param path
 * @param envVariable
 */
export function buildPath(path: string, envVariable?: string) {
    if (typeof envVariable === "undefined") {
        return path
    }

    return `${envVariable}${path}`
}

export function resolveApiUrl() {
    if (process.env.NODE_ENV !== "production") {
        return buildPath("/", process.env.REACT_APP_API_REST)
    }

    return `${window.location.origin}/v2/`
}

export function resolveWSUrl() {
    if (process.env.NODE_ENV !== "production") {
        return buildPath("", process.env.REACT_APP_WS)
    }

    return `wss://${window.location.host}/v2/record/ws`
}
